/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, SVGIcon, theme } from "@nordcloud/gnui";
import {
  ArrowWrap,
  BoxWrap,
  DropdownWrapper,
  DropdownWrapStyle,
} from "../../styles";
import { UserDropdown } from "./UserDropdown";

type DropdownWrapProps = {
  children?: React.ReactNode;
};

export function DropdownWrap({ children }: DropdownWrapProps) {
  return (
    <DropdownWrapStyle>
      <BoxWrap>
        <FlexContainer
          columnGap={theme.spacing.spacing02}
          css={{
            borderRadius: theme.radiusDefault,
            padding: `0.375rem ${theme.spacing.spacing02}`,
            "&:hover": {
              backgroundColor: theme.color.interactive.secondaryHover,
            },
          }}
        >
          {children}
          <ArrowWrap>
            <SVGIcon name="down" />
          </ArrowWrap>
        </FlexContainer>
        <DropdownWrapper width="15rem">
          <UserDropdown />
        </DropdownWrapper>
      </BoxWrap>
    </DropdownWrapStyle>
  );
}
